import { DocumentTypeByRecordMode, RecordFilter } from '@/types/api';
import { modeToTitle } from '@/components/Approval/utils/functions';

export const getDocumentDetailParam = (documentItem: RecordFilter) => {
  const { docId, subject, mode } = documentItem;
  return {
    post_category: modeToTitle(DocumentTypeByRecordMode[mode]),
    contents: subject,
    contents_id: docId,
  };
};
